/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link, NavLink } from 'react-router-dom';

import styles from '../styles/uikitNavigationNavToggle.module.scss';

const NavToggle = forwardRef(
  ({ selectedValue = '', tabs = [], ariaLabel = '', className = '', testId = '' }, ref) => {
    if (tabs.length < 2) return null;

    const tabComponents = tabs.slice(0, 4).map((tab) => {
      const Element = tab.isNavLink ? NavLink : Link;
      const validNavLinkProps = tab.isNavLink ? tab.navLinkProps : {};
      const isActive = selectedValue === tab.key || tab.isSelected;

      return (
        <li
          className={classnames(className, styles.navListItem)}
          data-testid={tab.testId}
          id={tab.id}
          key={tab.key}
        >
          <Element
            {...validNavLinkProps}
            aria-current={isActive ? 'page' : null}
            className={classnames(styles.navLink, isActive ? styles.isSelected : '')}
            to={tab.to}
          >
            {tab.text}
          </Element>
        </li>
      );
    });

    return (
      <nav
        className={classnames(styles.element, className)}
        aria-label={ariaLabel}
        data-testid={testId}
        ref={ref}
      >
        <ul className={styles.navList}>{tabComponents}</ul>
      </nav>
    );
  },
);

NavToggle.propTypes = {
  selectedValue: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      isNavLink: PropTypes.bool,
      isSelected: PropTypes.bool,
      key: PropTypes.string.isRequired,
      navLinkProps: PropTypes.shape({
        caseSensitive: PropTypes.bool,
        end: PropTypes.bool,
        exact: PropTypes.bool,
        reloadDocument: PropTypes.bool,
        strict: PropTypes.bool,
      }),
      testId: PropTypes.string,
      text: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    }),
  ),
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export { NavToggle as NavToggleStorybook };
export default memo(NavToggle);
